<template>
  <div>
    <projectTable :operateColumns="operateColumns" :extraQuery="extraQuery" @projectChange="getFlowLog" ref="projectTable">
      <Button slot="extraBtn" type="primary" style="margin-left:10px;" @click="searchExamineProject">{{filterBtnName}}</Button>
      <Button slot="extraBtn" type="success" style="margin-left:10px;" @click="expertReport">专家费汇总表</Button>
      <span slot="extraBtn" style="color:#ed4014;margin-left:20px;font-size:14px;">（提示：审核人员快速过滤需审核项目请点击审核项目筛选）</span>
    </projectTable>
    <Modal title="专家费借支证明单" v-model="feeFormVisible" width="800" class="expert-form-modal" :mask-closable="false">
      <expertFeeForm :projectData="selectProject" ref="expertFeeForm" :uploadFileInit="fileInit" :flowHistoryData="flowDetailHistory"></expertFeeForm>
      <div slot="footer">
        <!-- <Button type="success" @click="expertFeePrint">打印预览</Button> -->
        <Button @click="feeFormVisible=false">取消</Button>
        <Button @click="saveExpertForm" type="primary">保存</Button>
      </div>
    </Modal>
    <!-- 流程分支选择 -->
    <flowBranch
      ref="flowBranch"
      :visible="branchVisible"
      :branchList="flowBranch"
      @visibleChange="visibleChange"
      @branchChoose="branchChoose"
      :branchType="branchType"
    ></flowBranch>
    <!-- 流程人员选择 -->
    <Modal
      v-model="peopleSelectVisible"
      class="flow-modal"
      width="700px"
      title="流程人员选择"
    >
      <flowNext
        :child-msg="flowPeople"
        @toparentevent="handlePeopleSelect"
      ></flowNext>
      <div slot="footer">
        <Button @click="peopleSelectVisible=false">取消</Button>
        <Button @click="startFlow" type="primary">确定</Button>
      </div>
    </Modal>
    <Modal v-model="flowHistoryVisible" title="流程详情" width="800">
      <Button type="primary" size="small" @click="resetFlow" v-show="resetable" style="margin-bottom:15px">重置流程</Button>
      <flowHistory :flowDetailHistory="flowDetailHistory"></flowHistory>
      <div slot="footer"></div>
    </Modal>
    <!-- 专家费打印预览 -->
    <!-- <Modal v-model="expertFeePrintVisible" title="专家费借支申请表">
      <expertFeePrint :expertFeeData="expertFeeData"></expertFeePrint>
    </Modal> -->
  </div>
</template>

<script>
import { approvalFlow, getActivityUsers, deliverFlow, getFlowHistory, rejectFlow, getRejectActivityUsers, startWorkflow, endFlow } from '@/lib/flow'
import ProjectTable from '@/components/projectTable'
import ExpertFeeForm from './expertFeeForm'
import FlowBranch from '@/components/flow/flowBranch'
import FlowNext from '@/components/flow/flowNext'
import FlowHistory from '@/components/flow/flowHistory'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import qs from 'qs'
import { formatDate, guid } from '@/lib/tool'
import { fileUtil } from '@/lib/abpfile'
// import ExpertFeePrint from './expertFeePrint'

const bucket = 'chinapsp-yw'
const dir = 'expertFee/'
const fileType = 1

export default {
  name: 'expertFee',
  components: {
    ProjectTable,
    ExpertFeeForm,
    FlowBranch,
    FlowNext,
    FlowHistory,
    // ExpertFeePrint
  },
  data() {
    return {
      // expertFeeData: {},
      // expertFeePrintVisible: false,
      selectProject: {},
      feeFormVisible: false,
      operateColumns: [
        {
          title: '流程状态',
          width: 100,
          render: (h, params) => {
            if (params.row.flowLog && params.row.flowLog.reviewStatus) {
              return h('div', params.row.flowLog.reviewStatus)
            }
            return h('div', '未发起')
          }
        },
        {
          title: '审核人',
          width: 80,
          render: (h, params) => {
            if (params.row.flowLog && params.row.flowLog.reviewPerson) {
              return h('div', params.row.flowLog.reviewPerson)
            }
            return h('div', '未发起')
          }
        },
        {
          title: '操作',
          width: 340,
          render: (h, params) => {
            let startDisabled = true // 流程发起按钮控制
            let nextDisabled = true // 流程流转按钮控制
            let endDisabled = true // 流程退回按钮控制
            let operatorDisabled = params.row.flowLog ? (this.user.name === params.row.flowLog.reviewPerson ? true : false) : false
            if (params.row.flowLog && params.row.flowLog.reviewStatus === '未发起') {
              startDisabled = false
            }
            if (params.row.flowLog && params.row.flowLog.reviewStatus !== '未发起' && operatorDisabled) {
              nextDisabled = false
            }
            if (params.row.flowLog && (params.row.flowLog.reviewStatus.indexOf('发起人') !== -1 || params.row.flowLog.reviewStatus !== '未发起') && operatorDisabled && params.row.flowLog.reviewStatus.indexOf('退回') === -1) {
              endDisabled = false
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: async () => {
                    this.selectProject = params.row
                    this.feeFormVisible = true
                    // 获取流程详情
                    if (!params.row.flowLog.workFlowId) {
                      return
                    }
                    this.flowDetailHistory = []
                    let rep = await getFlowHistory(this.user.phoneNumber, params.row.flowLog.workFlowId)
                    this.flowDetailHistory = rep
                  }
                }
              }, '借支证明单'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: startDisabled
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '温馨提示',
                      content: '专家费借支功能已转移到采联业务系统4.0，请到业务系统4.0【借支流程】处使用该功能。',
                      cancelText: '取消',
                      okText: '立即前往',
                      onOk: () => {
                        if (isWeiXin()) {
                          window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
                        } else {
                          window.open('https://qy.choicelink.cn:8440')
                        }
                      }
                    })
                    return
                    /* if (!params.row.flowLog.content) {
                      this.$Message.info('请先填写借支证明单')
                      return
                    }
                    this.selectProject = params.row
                    this.branchType = 'start'
                    this.getBranch() */
                  }
                }
              }, '发起'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: nextDisabled
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '温馨提示',
                      content: '专家费借支功能已转移到采联业务系统4.0，请到业务系统4.0【借支流程】处使用该功能。',
                      cancelText: '取消',
                      okText: '立即前往',
                      onOk: () => {
                        if (isWeiXin()) {
                          window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
                        } else {
                          window.open('https://qy.choicelink.cn:8440')
                        }
                      }
                    })
                    return
                    /* this.selectedPeople = ''
                    this.selectProject = params.row
                    this.branchType = 'next'
                    this.approvalFlowNext() */
                  }
                }
              }, '流转'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: endDisabled
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '温馨提示',
                      content: '专家费借支功能已转移到采联业务系统4.0，请到业务系统4.0【借支流程】处使用该功能。',
                      cancelText: '取消',
                      okText: '立即前往',
                      onOk: () => {
                        if (isWeiXin()) {
                          window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
                        } else {
                          window.open('https://qy.choicelink.cn:8440')
                        }
                      }
                    })
                    return
                    /* this.selectProject = params.row
                    this.branchType = 'reject'
                    this.rejectFlow() */
                  }
                }
              }, '退回'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: '温馨提示',
                      content: '专家费借支功能已转移到采联业务系统4.0，请到业务系统4.0【借支流程】处使用该功能。',
                      cancelText: '取消',
                      okText: '立即前往',
                      onOk: () => {
                        if (isWeiXin()) {
                          window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
                        } else {
                          window.open('https://qy.choicelink.cn:8440')
                        }
                      }
                    })
                    return
                    /* if (params.row.flowLog && params.row.flowLog.reviewStatus === '未发起') {
                      this.$Message.info('尚未发起流程')
                      return
                    }
                    this.selectProject = params.row
                    this.flowDetailHistory = []
                    let rep = await getFlowHistory(this.user.phoneNumber, params.row.flowLog.workFlowId)
                    this.flowDetailHistory = rep
                    this.flowHistoryVisible = true */
                  }
                }
              }, '流程详情'),
            ])
          }
        }
      ],
      extraQuery: {
        status: ' and (projectState == "已挂网文件售卖中" or projectState == "项目失败" or projectState == "开评标中" or projectState == "已开评标完" or projectState == "项目结项")',
        bidTimeLimit: ' and clMeetingRoom.id> "0"',
        flowExmineFilter: ''
      },
      branchVisible: false,
      flowBranch: [],
      flowPeople: {},
      peopleSelectVisible: false,
      flowDetailHistory: [],
      flowHistoryVisible: false,
      operateFlowTaskId: '',
      branchType: 'start',
      operateFlowHistory: [],
      fileInit: {
        action: '',
        extraData: {}
      },
      selectedPeople: '',
      filterBtnName: '审核项目筛选'
    }
  },
  async mounted() {
    let rep = await fileUtil.downloadInit(this.user.id, fileType, bucket, dir)
    this.fileInit = rep
  },
  computed: {
    // 流程单号
    wiid() {
      if (this.flowDetailHistory.length === 0) {
        return '未发起'
      }
      return this.flowDetailHistory[0].SheetId
    },
    user() {
      return this.$store.state.session.user
    },
    resetable() {
      return this.$store.getters['session/hasRoles']('分公司项目经理') || this.$store.getters['session/hasRoles']('财务流编辑')
    }
  },
  methods: {
    expertFeePrint() {
      this.expertFeePrintVisible = true
    },
    searchExamineProject() {
      if (this.filterBtnName === '审核项目筛选') {
        this.filterBtnName = '取消筛选'
        this.extraQuery.flowExmineFilter = this.user.name
      } else if (this.filterBtnName === '取消筛选') {
        this.filterBtnName = '审核项目筛选'
        this.extraQuery.flowExmineFilter = ''
      }
      // 更新数据
      this.$refs.projectTable.searchProject()
    },
    async getFlowLog(projectList = []) {
      const projectIds = projectList.map(p => p.id)
      let rep = await ajax.get(requestUrls.AbpFlowLog.GetPaged, {
        params: {
          projectIds: projectIds,
          filter: 'flowType=="专家费借支"'
        },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      })
      const flowLogList = rep.data.result.items
      this.$refs.projectTable.projectData.forEach((project, j) => {
        for (let i = 0; i < flowLogList.length; i++) {
          if (flowLogList[i].projectId === project.id) {
            this.$set(this.$refs.projectTable.projectData[j], 'flowLog', flowLogList[i])
            break
          }
        }
        if (!this.$refs.projectTable.projectData[j].flowLog) {
          this.$set(this.$refs.projectTable.projectData[j], 'flowLog', {
            reviewStatus: '未发起'
          })
        }
      })
    },
    async saveExpertForm() {
      return this.$Message.info(' 该功能已关闭，请到4.0系统使用专家费借支功能')
      // 流程信息需要添加进去
      /* const expertFormData = this.$refs.expertFeeForm.getResult()
      const flowLog = this.selectProject.flowLog
      const flowLogId = flowLog.id ? flowLog.id : ''
      const reviewStatus = flowLog.reviewStatus ? flowLog.reviewStatus : '未发起'
      const flowType = flowLog.flowType ? flowLog.flowType : '专家费借支'
      const reviewPerson = flowLog.reviewPerson ? flowLog.reviewPerson : ''
      const fileId = flowLog.fileId ? flowLog.fileId : ''
      const fileName = flowLog.fileName ? flowLog.fileName : ''
      const workFlowId = flowLog.workFlowId ? flowLog.workFlowId : ''
      if (reviewStatus.indexOf('借支转回收') !== -1 && this.$refs.expertFeeForm.newUpload.name === '' && !flowLog.fileId) {
        this.$Message.info('请上传回收证明文件')
        return
      }
      try {
        this.$Spin.show()
        let rep = await ajax.post(requestUrls.AbpFlowLog.CreateOrUpdate, {
          abpFlowLog: {
            id: flowLogId,
            contentJson: JSON.stringify(expertFormData),
            projectId: this.selectProject.id,
            reviewStatus: reviewStatus,
            flowType: flowType,
            reviewPerson: reviewPerson,
            fileId: fileId,
            fileName: fileName,
            workFlowId: workFlowId
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {
          // 上传文件
          let uploadResult = await this.$refs.expertFeeForm.uploadFile(rep.data.result.id)
          // 如果有上传文件
          if (uploadResult) {
            let abpFlowLog = JSON.parse(JSON.stringify(rep.data.result))
            abpFlowLog.fileId = uploadResult.fileId
            abpFlowLog.fileName = uploadResult.fileName
            ajax.post(requestUrls.AbpFlowLog.CreateOrUpdate, {
              abpFlowLog
            })
          }
          this.$Message.success('保存成功')
          // 刷新表格
          this.$refs.projectTable.refreshProject()
        } else {
          this.$Message.error('保存失败')
        }
      } catch (err) {
        this.$Spin.hide()
        console.error(err)
        this.$Message.error('保存失败')
      } */
    },
    async getBranch() {
      let rep = await getActivityUsers({ appId: 'ZJ', userPhone: this.user.phoneNumber})
      this.flowBranch = rep
      this.branchVisible = true
    },
    handlePeopleSelect(selectedPeople) {
      this.selectedPeople = selectedPeople
    },
    async startFlow() {
      if (this.selectedPeople === '' && this.flowPeople.NextActivityName !== '结束') {
        this.$Message.error('请先选择流程人员')
        return
      }
      if (this.branchType === 'start') {
        const wfGuid = guid()
        let thisUser = {
          appId: 'ZJ',
          userPhone: this.user.phoneNumber,
          wiid: wfGuid, // 生成一个guid
          flowTitle: `专家费借支-${this.selectProject.projectFull}`,
          businessKey: '',
          opinion: this.$refs.flowBranch.opinion
        }
        let nextUser = {
          nextActivityCode: this.flowPeople.NextActivityCode,
          userId: this.selectedPeople.userId
        }
        this.$Spin.show()
        try {
          let rep = await startWorkflow(thisUser, nextUser)
          this.$Message.success('流程发起成功')
          this.peopleSelectVisible = false
          // 修改FlowLog信息
          let reviseFlowLog = this.selectProject.flowLog
          await ajax.post(requestUrls.AbpFlowLog.CreateOrUpdate, {
            abpFlowLog: {
              id: reviseFlowLog.id,
              content: reviseFlowLog.content,
              projectId: this.selectProject.id,
              reviewPerson: this.selectedPeople.userName,
              flowType: reviseFlowLog.flowType,
              reviewStatus: this.flowPeople.NextActivityName,
              workFlowId: wfGuid,
              fileId: reviseFlowLog.fileId,
              fileName: reviseFlowLog.fileName,
            }
          })
          this.$Spin.hide()
          // 刷新表格
          this.$refs.projectTable.refreshProject()
          this.selectedPeople = ''
          this.flowPeople = {}
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('发起流程失败')
        }
      }
      if (this.branchType === 'next') {
        if (this.flowPeople.NextActivityName !== '结束') {
          // 流程转交
          try {
            this.$Spin.show()
            let rep = await deliverFlow(this.user.phoneNumber, { taskId: this.operateFlowTaskId, nextActivityCode: this.flowPeople.NextActivityCode, userId: this.selectedPeople.userId, opinion: this.$refs.flowBranch.opinion })
            this.$Message.success('流程流转到下一步')
            this.peopleSelectVisible = false
            // 修改FlowLog信息
            let reviseFlowLog = this.selectProject.flowLog
            await ajax.post(requestUrls.AbpFlowLog.CreateOrUpdate, {
              abpFlowLog: {
                id: reviseFlowLog.id,
                content: reviseFlowLog.content,
                projectId: this.selectProject.id,
                reviewPerson: this.selectedPeople.userName,
                flowType: reviseFlowLog.flowType,
                reviewStatus: this.flowPeople.NextActivityName,
                workFlowId: reviseFlowLog.workFlowId,
                fileId: reviseFlowLog.fileId,
                fileName: reviseFlowLog.fileName
              }
            })
            this.$Spin.hide()
            // 刷新表格
            this.$refs.projectTable.refreshProject()
            this.selectedPeople = ''
            this.flowPeople = {}
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('流程转交失败')
          }
        } else {
          // 结束流程
          try {
            this.$Spin.show()
            let rep = await endFlow(this.user.phoneNumber, { taskId: this.operateFlowTaskId, nextActivityCode: this.flowPeople.NextActivityCode, opinion: this.$refs.flowBranch.opinion })
            this.$Message.success('流程结束成功')
            this.peopleSelectVisible = false
            // 修改FlowLog信息
            let reviseFlowLog = this.selectProject.flowLog
            await ajax.post(requestUrls.AbpFlowLog.CreateOrUpdate, {
              abpFlowLog: {
                id: reviseFlowLog.id,
                content: reviseFlowLog.content,
                projectId: this.selectProject.id,
                reviewPerson: '结束',
                flowType: reviseFlowLog.flowType,
                reviewStatus: this.flowPeople.NextActivityName,
                workFlowId: reviseFlowLog.workFlowId,
                fileId: reviseFlowLog.fileId,
                fileName: reviseFlowLog.fileName,
              }
            })
            this.$Spin.hide()
            // 刷新表格
            this.$refs.projectTable.refreshProject()
            this.selectedPeople = ''
            this.flowPeople = {}
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('流程结束失败')
          }
        }
      }
    },
    async rejectFlow() {
      // 获取流程人员
      this.$Spin.show()
      try {
        // 获取taskId,taskId通过读取历史最后一个流程信息获得
        this.operateFlowHistory = []
        let hisRep = await getFlowHistory(this.user.phoneNumber, this.selectProject.flowLog.workFlowId)
        this.operateFlowHistory = hisRep
        this.operateFlowTaskId = hisRep[hisRep.length-1].TaskId
        let rep = await getRejectActivityUsers(this.user.phoneNumber, this.operateFlowTaskId)
        this.$Spin.hide()
        this.flowBranch = rep
        this.branchVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回流程获取失败')
      }
    },
    async approvalFlowNext() {
      if (this.selectProject.flowLog.reviewStatus.indexOf('借支转回收') !== -1 && !this.selectProject.flowLog.fileId) {
        this.$Message.info('请先填写完整回收信息')
        return
      }
      this.$Spin.show()
      // 获取流程人员
      try {
        // 获取taskId,taskId通过读取历史最后一个流程信息获得
        this.operateFlowHistory = []
        let hisRep = await getFlowHistory(this.user.phoneNumber, this.selectProject.flowLog.workFlowId)
        this.operateFlowHistory = hisRep
        this.operateFlowTaskId = hisRep[hisRep.length-1].TaskId
        const total = this.$refs.expertFeeForm.getApplyTotal()
        const processVariablesJson = JSON.stringify([{ key: 'Num', value: total }])
        let rep = await getActivityUsers({ appId: 'ZJ', userPhone: this.user.phoneNumber, taskId: this.operateFlowTaskId, processVariablesJson: processVariablesJson })
        this.$Spin.hide()
        this.flowBranch = rep
        this.branchVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('流程人员获取失败')
      }
    },
    branchChoose(val) {
      this.flowPeople = val
      if (this.branchType === 'next' || this.branchType === 'start') {
        this.peopleSelectVisible = true
      }
      if (this.branchType === 'reject') {
        if (this.$refs.flowBranch.opinion === '') {
          this.$Message.info('请填写退回原因')
          return
        }
        this.rejectFlowConfirm()
      }
      this.branchVisible = false
    },
    async rejectFlowConfirm() {
      this.$Spin.show()
      try {
        let rep = await rejectFlow(this.user.phoneNumber, { taskId: this.operateFlowTaskId, activityCode: this.flowPeople.ActivityCode, opinion: this.$refs.flowBranch.opinion })
        
        this.$Message.success('退回操作成功')
        // 更新flowLog记录信息
        let reviewPerson = this.flowPeople.ActivityName
        for (let i = 0; i < this.operateFlowHistory.length; i++) {
          if (this.operateFlowHistory[i].ActivityName === this.flowPeople.ActivityName) {
            reviewPerson = this.operateFlowHistory[i].RealName
            break
          }
        }

        let reviseFlowLog = this.selectProject.flowLog
        await ajax.post(requestUrls.AbpFlowLog.CreateOrUpdate, {
          abpFlowLog: {
            id: reviseFlowLog.id,
            content: reviseFlowLog.content,
            projectId: this.selectProject.id,
            reviewPerson: reviewPerson,
            flowType: reviseFlowLog.flowType,
            reviewStatus: `${this.flowPeople.ActivityName}(退回)`,
            workFlowId: reviseFlowLog.workFlowId,
            fileId: reviseFlowLog.fileId,
            fileName: reviseFlowLog.fileName,
          }
        })
        this.$Spin.hide()
        // 刷新表格
        this.$refs.projectTable.refreshProject()
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回操作失败')
      }
    },
    visibleChange(val) {
      this.branchVisible = val
    },
    expertReport() {
      window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2FExpertFees%2FExpertFees.cpt`)
    },
    resetFlow() {
      let id = this.selectProject.flowLog.id
      this.$Modal.confirm({
        title: '重置提示',
        content: '确定要重置该流程吗（重置后旧流程不可恢复，可重新发起新流程）？',
        onOk: () => {
          ajax.delete(`/api/services/app/AbpFlowLog/Delete?id=${id}`).then(res => {
            this.flowHistoryVisible = false
            this.$Message.success('重置成功，流程已删除')
            // 刷新表格
            this.$refs.projectTable.refreshProject()
            this.selectedPeople = ''
            this.flowPeople = {}
          })
        },
        onCancel: () => {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.expert-form-modal {
  /deep/ .ivu-modal {
    top: 20px;
  }
}
</style>
